// src/pages/user/Settings.js
// Page paramètres utilisateur - NE PAS MODIFIER

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../components/shared/LanguageSwitcher';

const Settings = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [notifications, setNotifications] = useState(true);
  const [geolocation, setGeolocation] = useState(false);

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh' },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '16px',
      position: 'sticky',
      top: 0,
      backgroundColor: '#0A0E1A',
      zIndex: 50,
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: '#FFFFFF',
      fontSize: '20px',
      cursor: 'pointer',
      padding: '4px',
    },
    title: { fontSize: '20px', fontWeight: '700', color: '#FFFFFF' },
    section: {
      padding: '8px 16px',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    sectionTitle: {
      fontSize: '13px',
      fontWeight: '600',
      color: '#4A5568',
      textTransform: 'uppercase',
      padding: '12px 0 4px',
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '14px',
      backgroundColor: '#162033',
      borderRadius: '10px',
      border: '1px solid rgba(255, 255, 255, 0.05)',
    },
    rowLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      fontSize: '15px',
      color: '#FFFFFF',
    },
    toggle: {
      width: '48px',
      height: '28px',
      borderRadius: '14px',
      cursor: 'pointer',
      position: 'relative',
      transition: 'background-color 200ms',
    },
    toggleKnob: {
      position: 'absolute',
      top: '2px',
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      backgroundColor: '#FFFFFF',
      transition: 'left 200ms',
    },
  };

  const Toggle = ({ value, onChange }) => (
    <div
      style={{
        ...styles.toggle,
        backgroundColor: value ? '#FFD700' : '#4A5568',
      }}
      onClick={() => onChange(!value)}
    >
      <div style={{ ...styles.toggleKnob, left: value ? '22px' : '2px' }} />
    </div>
  );

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Paramètres | Fynho</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate(-1)}>←</button>
        <div style={styles.title}>⚙️ {t('common.settings')}</div>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>Général</div>
        <div style={styles.row}>
          <span style={styles.rowLabel}>🌍 {t('common.language')}</span>
          <LanguageSwitcher compact />
        </div>
        <div style={styles.row}>
          <span style={styles.rowLabel}>🔔 Notifications</span>
          <Toggle value={notifications} onChange={setNotifications} />
        </div>
        <div style={styles.row}>
          <span style={styles.rowLabel}>📍 Géolocalisation</span>
          <Toggle value={geolocation} onChange={setGeolocation} />
        </div>
      </div>
    </div>
  );
};

export default Settings;